import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router'
import 'url-search-params-polyfill';
Vue.use(Vuex);


export const store = new Vuex.Store({
   
    state: {
       youtube: {
            youtube_category:[],
            selected_youtube_category:-1,
            youtube_item_list:[],
            page: new URLSearchParams(window.location.search).get("page") ? new URLSearchParams(window.location.search).get("page") : 1,
            content_length:1,    
            all_count:0,
            search_text:""
        },
        product: {
            product_category:[],
            selected_product_category:-1,
            product_detail_category:[],
            selected_product_detail_category:-1,
            product_item_list:[],
            page: new URLSearchParams(window.location.search).get("page") ? new URLSearchParams(window.location.search).get("page") : 1,
            content_length:1,    
            all_count:0,
            detail_all_count:0,
            is_premium_view:true
        },
        used_product: {
            product_category:[],
            selected_product_category:-1,         
            product_item_list:[],
            page: new URLSearchParams(window.location.search).get("page") ? new URLSearchParams(window.location.search).get("page") : 1,
            content_length:1,    
            all_count:0,
            is_premium_view:true
        },
    },
    getters:{      
    },
    mutations:{
        set_youtube_all_count(state,payload){ state.youtube.all_count=payload},
        set_youtube_data_refresh(state, payload){
            state.youtube.youtube_category=[]
            state.youtube.selected_youtube_category=-1
            state.youtube.youtube_item_list=[]
            state.youtube.page= new URLSearchParams(window.location.search).get("page") ? new URLSearchParams(window.location.search).get("page") : 1
            state.youtube.content_length=1
        },
        set_youtube_category(state, payload) {            
            state.youtube.youtube_category = payload
        },
        set_selected_youtube_category(state, payload) {
            state.youtube.selected_youtube_category = payload
        },
        set_youtube_item_list(state,payload){
            state.youtube.youtube_item_list = payload
        },
        set_youtube_page(state,payload){
            state.youtube.page = payload
        },
        set_youtube_content_length(state,payload){
        state.youtube.content_length = payload
        },
        set_product_all_count(state,payload){ state.product.all_count=payload},
        set_product_detail_all_count(state,payload){ state.product.detail_all_count=payload },
        set_product_data_refresh(state, payload){
            state.product.product_category=[]
            state.product.selected_product_category=-1
            state.product.product_item_list=[]
            state.product.page= new URLSearchParams(window.location.search).get("page") ? new URLSearchParams(window.location.search).get("page") : 1
            state.product.content_length=1
        },
        set_product_category(state, payload) {            
            state.product.product_category = payload
        },
        set_selected_product_category(state, payload) {
            state.product.selected_product_category = payload
        },
        set_product_item_list(state,payload){
            state.product.product_item_list = payload
        },
        set_product_page(state,payload){
            state.product.page = payload
        },
        set_product_content_length(state,payload){
            state.product.content_length = payload
        },
        refresh_product_detail_category(state){
            try{
                state.product.product_detail_category = state.product.product_category.find(e=>e.id==state.product.selected_product_category).detail_category
                // 변경후 전체를 선택해준다
                state.product.selected_product_detail_category = -1

                state.product.detail_all_count = 0
                for(let k= 0 ; k < state.product.product_detail_category.length; k++){
                    state.product.detail_all_count = state.product.detail_all_count + state.product.product_detail_category[k]["count"]
                }  
            }
            catch(e){
                state.product.product_detail_category = []
            }
        },

        set_used_product_all_count(state,payload){ state.used_product.all_count=payload},
        set_used_product_data_refresh(state, payload){
            state.used_product.product_category=[]
            state.used_product.selected_product_category=-1
            state.used_product.product_item_list=[]
            state.used_product.page= new URLSearchParams(window.location.search).get("page") ? new URLSearchParams(window.location.search).get("page") : 1
            state.used_product.content_length=1
        },
        set_used_product_category(state, payload) {            
            state.used_product.product_category = payload
        },
        set_used_selected_product_category(state, payload) {
            state.used_product.selected_product_category = payload
        },
        set_used_product_item_list(state,payload){
            state.used_product.product_item_list = payload
        },
        set_used_product_page(state,payload){
            state.used_product.page = payload
        },
        set_used_product_content_length(state,payload){
            state.used_product.content_length = payload
        },
    }
  })


// WEBPACK FOOTER //
// ./src/store/store.js